<p-toast></p-toast>

<p-card header="">
	<div class="p-mb-2" *ngIf="status != null; else infoMessage">
		<ng-container *ngTemplateOutlet="statusinfo"></ng-container>
	</div>
</p-card>

<ng-template #statusinfo>

	<p-accordion>
		<p-accordionTab header="Status cpu's:">
			<div class="p-grid">
				<div class="p-col-3" *ngFor="let c of cpuData">
					<p-chart type="doughnut" [data]="c"></p-chart>
				</div>
			</div>
		</p-accordionTab>
	</p-accordion>


</ng-template>

<ng-template #infoMessage>
	<p-card styleClass="p-mb-2">
		<p>
			Bezig met ophalen status....
		</p>
	</p-card>
</ng-template>
